// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <div class="title h4">
            "Отвалы" игроков:
            <span ng-show="!aggr">(не задан диапазон миссий)</span>
            <span ng-show="aggr">
                с {{ aggr.min_mission }} по {{ aggr.max_mission }} миссию прошли {{ aggr.win_rate | number: 2 }}% игроков
            </span>
        </div>
        <div class="pull-right">
            <a href="{{ aggr.caption_url }}">{{ aggr.caption_text }}</a>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="paywalls.CampaignWinRateUniqueChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="paywalls.CampaignMissionPlayersChart"></bfg-chart>
    </div>
</div>

<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="paywalls.CampaignMissionWinnersChart"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;